module.exports = __webpack_public_path__ + "img/1545396517.c0ea4e17.jpg";